<div class="upload-wrapper">
  <ng-container>
    <label>
      <input (change)="selectFilesAndUpload($event)" hidden multiple type="file">
      <ng-container *ngIf="!selectedFile">
        <img src="assets/icons/photoupdate.svg"/>
      </ng-container>
      <ng-container *ngIf="selectedFile">
        <div class="certificate">
          <div class="file-name">{{ selectedFileName }}</div>
        </div>x
      </ng-container>
    </label>
    <div *ngIf="message">
      <p>{{ message }}</p>
    </div>
  </ng-container>
</div>
